/** 主题颜色列表 */
export const themeColors = import.meta.glob('./module/*.json')
